import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-card__left-content" }
const _hoisted_2 = { class: "order-card__status" }
const _hoisted_3 = { class: "order-card__info" }
const _hoisted_4 = { class: "order-card__id" }
const _hoisted_5 = { class: "order-card__date" }
const _hoisted_6 = { class: "order-card__right-content" }
const _hoisted_7 = { class: "order-card__total-sum" }
const _hoisted_8 = { class: "order-card__btn" }

import IconCheck from '@/icons/icon-check.vue';
import IconArrowRight from '@/icons/icon-arrow-right.vue';
import { PropType } from 'vue';
import { Order } from '@/types/app';
import moment from 'moment';
import IconTime from '@/icons/icon-time.vue';
import IconCross from '@/icons/icon-cross.vue';
import helpers from '../helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
  order: {
    type: Object as PropType<Order>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

let orderStatus: 'success' | 'waiting' | 'error' = 'error';
if (props.order.orderStatusId === 5) {
  orderStatus = 'success';
} else if (props.order.orderStatusId === 1 || props.order.orderStatusId === 2) {
  orderStatus = 'waiting';
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'order', params: { orderId: __props.order.orderId } },
    class: _normalizeClass([
      'order-card',
      `order-card--${_unref(orderStatus)}`,
    ])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(orderStatus) === 'success')
            ? (_openBlock(), _createBlock(IconCheck, { key: 0 }))
            : (_unref(orderStatus) === 'waiting')
              ? (_openBlock(), _createBlock(IconTime, { key: 1 }))
              : (_openBlock(), _createBlock(IconCross, { key: 2 }))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "№" + _toDisplayString(__props.order.orderId), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(moment)(__props.order.dateAdded).format('DD.MM.YYYY HH:mm')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(helpers).formatCurrency(__props.order.total)), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(IconArrowRight)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})